/* TODO: t() */
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import FormFieldEditor from '../helpers/FormFieldEditor';
import { Checkbox, Text } from '../../../uiold';

import FileUploadElement from '../FileUploadElement';
import Dropdown from '../../../uiold/DropdownSimple';
import {
  DATE_TYPES,
  getName,
  getPlaceholder,
} from '../TextInputElement/validators';
import {
  NONE,
  Option,
} from '../TextInputElement/TextInputElementFieldEditorView';
import FormBuilderActions from '../../../../support/FormBuilderActions';

const OPTIONS: Array<Option> = [
  NONE,
  ...DATE_TYPES.map((type) => ({ name: getName(type), value: type })),
];

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValue: (key: string, newValue: unknown) => void;
  parent: FileUploadElement;
  renderNameInput: () => ReactElement;
  renderLabelInput: () => ReactElement;
};

function EditorView(props: EditorViewProps) {
  let { data, updateValue, parent, renderNameInput, renderLabelInput } = props;
  const validationType = parent.definition.field_validation;

  const onValidationTypeChange = (option: Option) => {
    let { parent } = props;
    let validationType = option.value;
    let newPlaceholder = getPlaceholder(validationType);
    FormBuilderActions.updateField(parent, {
      field_validation: validationType,
      placeholder: newPlaceholder || parent.definition.placeholder,
    });
  };

  return (
    <View>
      {renderNameInput()}
      {renderLabelInput()}
      <Checkbox
        text="Image Only"
        isChecked={!!data.image_only}
        onChange={(value) => updateValue('image_only', value)}
      />
      <Checkbox
        isDisabled={!!data.isSystemField}
        text={t('Required')}
        isChecked={!!data.isSystemField || !!data.is_required}
        onChange={(value) => updateValue('is_required', value)}
      />
      <Checkbox
        text={t('Include expiry field')}
        isChecked={!!data.includeExpiry}
        onChange={(value) => updateValue('includeExpiry', value)}
      />
      {data.includeExpiry && (
        <View accessibilityRole="label" style={styles.field}>
          <Text style={styles.label}>{t('Validation')}</Text>
          <Dropdown
            options={OPTIONS}
            selectedItem={
              OPTIONS.find((option) => option.value === validationType) || NONE
            }
            onChange={onValidationTypeChange}
          />
        </View>
      )}
    </View>
  );
}

type Props = {
  parent: FileUploadElement;
};

class FileUploadFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return <FormFieldEditor component={EditorView} parent={parent} />;
  }
}

let styles = StyleSheet.create({
  field: {
    marginVertical: 10,
  },
  label: {
    fontWeight: 'normal',
  },
});

export default FileUploadFieldEditorView;
